"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiConfig = void 0;
const apiConfig = (env) => {
    switch (env) {
        case "v2":
        default:
            return {
                apiurl: "https://api.akord.com",
                gatewayurl: "https://akrd.net",
            };
        case "dev":
            return {
                apiurl: "https://api.akord.link",
                gatewayurl: "https://akrd.io",
            };
    }
};
exports.apiConfig = apiConfig;
